// Author: Yvon K. Awuklu
// Purpose: Provide the shared four-dot waiting indicator for pages, tables, and actions.
import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import './loadingIndicator.scss';

export default function LoadingIndicator({size = 28, color, label, decorative = false, className = '', style, ...props}) {
  const {t} = useTranslation();
  return <span
    className={`ui-loading-indicator ${className}`}
    style={{'--ui-loading-size': typeof size === 'number' ? `${size}px` : size, ...(color === 'inherit' ? {color: 'inherit'} : {}), ...style}}
    role={decorative ? undefined : 'status'}
    aria-label={decorative ? undefined : (label || t('ui.loading'))}
    aria-hidden={decorative || undefined}
    {...props}
  >
    <span className="ui-loading-dots" aria-hidden="true">
      <i/><i/><i/><i/>
    </span>
  </span>;
}

LoadingIndicator.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  color: PropTypes.oneOf(['primary', 'inherit']),
  label: PropTypes.string,
  decorative: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
};
